export enum RegisterType {
  PF = 'pf',
  PJ = 'pj',
}
